import styled from '@emotion/styled'

export const Sidebar = styled.div`
  grid-area: sidebar;
  border: lightgray 1px solid;
  position: fixed;
  height: 100vh;
  background: white;
  z-index: 99;

  @media (max-width: 835px) {
    display: none;
  }

  @media (min-width: 836px) {
    display: fixed;
  }

  .visible {
    display: block;
  }

  .hidden {
    display: none;
  }

  .toggle-button {
    display: inline-block;
    width: 0px;
    height: 0px;
    margin-right: 50px;
  }

  .toggle-button:hover .visible {
    display: none;
  }

  .toggle-button:hover .hidden {
    display: block;
    cursor: pointer;
  }
`

export const MobileSidebar = styled.div`
  border: lightgray 1px solid;
  position: absolute;
  height: 100vh;
  background: white;
  z-index: 999;

  @media (min-width: 836px) {
    display: none;
  }

  .toggle-button {
    display: inline-block;
    width: 0px;
    height: 0px;
    margin-right: 50px;
    &:hover {
      cursor: pointer;
    }
  }
`

export const SidebarNavigationMenu = styled.div`
  height: 100%;
  font-size: 16px;
  font-family: Montserrat, sans-serif !important;
  font-weight: 500;
  & li {
    list-style-type: none;
  }
  .sidebar-open {
    width: 100%;
  }
  .sidebar-collapse {
  }
  .menu-item {
    text-decoration: none !important;
    gap: 4%;
  }
  button.menu-item {
    background: none;
    border: none;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    padding: 0.5rem 1rem;
    display: flex;
    align-items: center;
    color: #6f6f6f;
    font-size: 12px;
    font-family: Montserrat, sans-serif;
    font-weight: 500;
  }
  button.menu-item:focus {
    outline: none;
    box-shadow: none;
  }
  & .nav-link.menu-item.active,
  & button.menu-item.active {
    position: relative;
    background-color: rgba(255, 80, 0, 0.2);
  }
  .menu-item:hover {
    color: black !important;
  }
  .submenu-item {
    margin-left: 1.25rem;
    border-left: 2px solid rgba(255, 80, 0, 0.25);
    border-radius: 0 4px 4px 0;
    transition: border-color 0.15s ease;
  }
  .submenu-item.submenu-item-active {
    border-left-color: #ff5000;
  }
  .submenu-item .nav-link {
    padding-left: 1rem !important;
    font-size: 12px;
  }
  & .nav-item.show {
    display: flex;
    position: absolute;
    margin-left: -40px;
  }
  & .nav-item.hide {
    display: none;
  }
  .sidebar-group-wrapper {
    position: relative;
  }
  .sidebar-group-popout {
    display: none;
    position: absolute;
    left: 100%;
    top: 0;
    background: white;
    border: 1px solid lightgray;
    border-radius: 4px;
    z-index: 10;
    min-width: 180px;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.12);
    padding: 4px 0;
  }
  .sidebar-group-wrapper:hover .sidebar-group-popout {
    display: block;
  }
`

export const TabOptionsContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background: #e8e8e8;
  border-radius: 8px;
  padding: 3px;
  gap: 2px;
`
